<template>
  <div class="evaluation-card-component" :class="{inEvaluationPage: inEvaluationPage}">
    <div class="card-left" v-if="!inEvaluationPage">
      <van-image
          round
          fit='contain'
          width="1.16rem"
          height="1.16rem"
          :src="cardData.avatar || require('../../assets/img/personalImg/defaultAvatar.png') "
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </div>
    <div class="card-right">
      <div class="card-title">
        <span class="text-overflow">
          <template v-if="inEvaluationPage">
            我的评价
          </template>
          <template v-else>
            {{itemData.userName}}
          </template>
        </span>
        <span class="reply-time">{{cardData.evaluationTime | timeHandleFilter}}</span>
      </div>
      <div class="card-rate">
        <van-rate
            v-model="cardData.evaluationStar"
            :size="inEvaluationPage ? '0.5rem' : '0.38rem'"
            :icon="require('../../assets/img/learningGuidePage/mini_star.png')"
            void-icon=""
            readonly
        />
      </div>
      <div class="card-content">{{cardData.evaluationContent}}</div>
      <div class="card-reply" v-if="cardData.replyContent">
        <div class="reply-title">
          <span class="reply-name">
            <span class="text-overflow">启小航</span>
            <span>回复</span>
          </span>
          <span class="reply-time">{{cardData.replyTime | timeHandleFilter}}</span>
        </div>
        <div class="reply-content">
          {{cardData.replyContent}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Image as VanImage } from 'vant';
import moment from 'moment';

Vue.use(VanImage);

export default {
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  filters: {
    timeHandleFilter(time) {
      return moment(time).format('YYYY/MM/DD HH:mm'); // 重置时间格式
    },
  },
  data() {
    return {
      rateValue: 2,
      cardData: {},
      inEvaluationPage: this.$route.name === 'evaluation',
    };
  },
  mounted() {
    this.itemData.evaluationStar = Number(this.itemData.evaluationStar);
    this.cardData = this.itemData;
  },
};
</script>

<style scoped lang="scss">
.evaluation-card-component {
  display: flex;
  margin-bottom: 36px;
  padding: 36px;
  background: $bgWhite;
  border-radius: 14px;

  .card-right{
    width: calc(100% - 116px);

    .card-title{
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        &:first-child{
          font-size: 29px;
          line-height: 40px;
        }
        &:last-child{
          color: $fontColorGray;
          font-size: 25px;
          line-height: 29px;
          white-space:nowrap;
          word-break:keep-all;
        }
      }
    }
  }

  .card-rate{
    display: flex;
    margin-top: 12px;
  }

  .card-left {
    width: 87px;
    margin-right: 29px;
  }

  .card-content {
    margin-top: 20px;
    color: #333;
    font-size: 28px;
    line-height: 40px;
    word-break: break-all;
  }

  .card-reply{
    width: 100%;
    margin-top: 22px;
    padding: 36px;
    background: $bgPrimaryColor;
    border-radius: 14px;

    .reply-title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      overflow: hidden;

      .reply-name {
        display: flex;
        margin-right: 10px;
        overflow: hidden;
        white-space:nowrap;
        word-break:keep-all;
        span{
          display: block;
          margin-right: 5px;
          font-size: 28px;
          line-height: 36px;
        }
      }
      .reply-time{
        color: $fontColorGray;
        font-size: 25px;
        line-height: 29px;
        white-space:nowrap;
        word-break:keep-all;
      }
    }
    .reply-content{
      margin-top: 22px;
      font-size: 28px;
      line-height: 38px;
      word-break: break-all;
    }
  }
}
.inEvaluationPage {
  .card-right {
    width: 100%;
  }
}
</style>
